import * as React from "react"
import * as ReactDOMClient from 'react-dom/client'
import StrideApp from "./StrideApp"

ReactDOMClient.createRoot(document.getElementById('root')).render(
    <>
        <StrideApp />
    </>
)
